import React, { Component } from "react";
import _ from "lodash";

class Tbody extends Component {
  renderCell = (item, column) => {
    if (column.content) return column.content(item);

    return _.get(item, column.path);
  };
  createKey = (item, column) => {
    return item._id + (column.path || column.key);
  };
  render() {
    const { data, columns } = this.props;
    return (
      <tbody>
        {data.map((item) => (
          <>
            {" "}
            <th scope="row">{item._id}</th>
            <tr key={item._id} style={{ fontSize: 21, marginTop: 20 }}>
              {columns.map((column) => (
                <td key={this.createKey(item, column)}>
                  {this.renderCell(item, column)}
                </td>
              ))}
            </tr>
          </>
        ))}
      </tbody>
    );
  }
}

export default Tbody;
